import {useVentrataClient} from 'hooks/useVentrataClient'
import {useCallback} from 'react'
import {Params, Ventrata} from 'types'
import {useRecaptchaToken, withRecaptchaRetry} from 'utils/recaptcha'
import {ORDER_HEADERS} from './orderHeaders'

export const useCreateOrderApiMethod = () => {
  const ventrata = useVentrataClient()
  const createRecaptchaToken = useRecaptchaToken()

  return useCallback(
    async ({expirationMinutes, currency}: Params.CreateOrder) => {
      return withRecaptchaRetry('cart_add', createRecaptchaToken, async (token) => {
        const recaptchaEnterprise: Params.RecaptchaToken = {token}

        const {data} = await ventrata.post<Ventrata.Order>(
          `/orders`,
          {
            expirationMinutes,
            currency,
            recaptchaEnterprise,
          },
          {
            headers: ORDER_HEADERS,
          }
        )

        return data
      })
    },
    [ventrata, createRecaptchaToken]
  )
}
